import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Header from './Header';

const Wrapper = styled.div`
  width: 100%;
`;

const TextareaWrapper = styled.div`
  p {
    width: 100%;
    color: #fff;
    margin: 0 0 1em;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  background-color: transparent;
  color: #fff;
  border: none;
  -webkit-appearance: none;
`;

const Note = ({ onRemove, onUpdateTreatment, value, summary, copy }) => (
  <Wrapper>
    <Header name={copy.note} onRemove={onRemove} summary={summary} />
    <TextareaWrapper>
      {summary ? (
        <p>{value}</p>
      ) : (
        <Textarea onChange={onUpdateTreatment} value={value} rows="5" placeholder="Add note here..." maxLength="255" />
      )}
    </TextareaWrapper>
  </Wrapper>
);

Note.defaultProps = {
  summary: false,
  onRemove: () => {},
  onUpdateTreatment: () => {},
};

Note.propTypes = {
  onRemove: PropTypes.func,
  onUpdateTreatment: PropTypes.func,
  value: PropTypes.string.isRequired,
  summary: PropTypes.bool,
  copy: PropTypes.shape({}).isRequired,
};

export default Note;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/NewVisitPage/Treatments/Note.js